import { Code } from '@chiroup/core/functions/Code';
import tiptapExtensionsBase from '@chiroup/core/functions/tiptapExtensionsBase';
import Emoji, { gitHubEmojis } from '@tiptap-pro/extension-emoji';
import Underline from '@tiptap/extension-underline';
import { emojiSuggestion } from './emojiSuggestion';

export const tiptapExtensions = [
  ...tiptapExtensionsBase,
  // User macros can carry underline; without this mark the editors that
  // receive a macro would drop it on insertion.
  Underline,
  // Placeholder.configure({
  //   placeholder: 'Enter a description...',
  // }),
  Code,
  Emoji.configure({
    emojis: gitHubEmojis,
    enableEmoticons: true,
    suggestion: emojiSuggestion,
  }),
];
